import {PolyNodeDataRegister} from '../../../@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeDataRegister';
import {NodeContext} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {BaseNodeType} from '../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
// import {PolyNodeDefinition} from '../../../@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeDefinition';
// import {NodeContext} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
// import {StoreController} from '../store/controllers/StoreController';
import {NodesCodeExporter} from '../../engine/io/code/export/Nodes';
import {CoreClipboard} from './CoreClipboard';
import {PolyNodeController} from '../../../@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeController';

export interface PolyNodeCRUDServerResponse {
	error?: string;
}
// export interface PolyNodeSaveData {
// 	nodeContext: NodeContext;
// 	nodeType: string;
// 	data: PolyNodeDefinition;
// }

// const DEFAULT_POLY_NODE_SAVE_MESSAGE = `poly node was not saved`;
export abstract class BasePolyNodeSaveController {
	constructor() {}

	static changeType(node: BaseNodeType, newType: string) {
		const parent = node.parent();
		if (!parent) {
			return;
		}

		const isNodeSelected = parent.childrenController?.selection.contains(node);

		// generate instructions to copy node, while making sure not to generate the children
		const exporter = new NodesCodeExporter([node], {ignoreGrandChildren: true, replaceTypeWith: newType});
		const lines: string[] = exporter.process_with_existing_nodes(parent, CoreClipboard.PARENT_NODE_VAR_NAME);
		let code = lines.join('\n');

		// remove type of current node if it is not a polyNode already
		// otherwise when running the code again it will simply create another subnet
		// if (!node.polyNodeController) {
		// 	// TODO: this should ideally be done inside the code exporter
		// 	const lineToReplace = `${node.name()} = parentNode.createNode('${node.type()}')`;
		// 	const lineUpdated = `${node.name()} = parentNode.createNode('${newType}')`;
		// 	console.log(lineToReplace);
		// 	console.log(lineUpdated);
		// 	code = code.replace(lineToReplace, lineUpdated);
		// }

		// delete
		parent.removeNode(node);

		// paste
		CoreClipboard.run(parent, code);
		const newNode = parent.node(node.name());
		if (isNodeSelected) {
			if (newNode) {
				parent.childrenController?.selection.add([newNode]);
			}
		}
		return newNode;
	}

	abstract readAndRegisterPolyNodes(): void;
	abstract create(
		node: BaseNodeType,
		polyNodeData: PolyNodeDataRegister<NodeContext>
	): Promise<BaseNodeType | undefined>;
	abstract update(
		node: BaseNodeType,
		polyNodeData: PolyNodeDataRegister<NodeContext>
	): Promise<BaseNodeType | undefined>;

	protected _createPolyNodeAndReplaceNode(node: BaseNodeType, polyNodeData: PolyNodeDataRegister<NodeContext>) {
		PolyNodeController.createNodeClassAndRegister(polyNodeData);
		const {type} = polyNodeData;
		const newNode = BasePolyNodeSaveController.changeType(node, type);
		return newNode;
	}
	protected _updatePolyNodeAndReplaceNodes(node: BaseNodeType, polyNodeData: PolyNodeDataRegister<NodeContext>) {
		PolyNodeController.createNodeClassAndRegister(polyNodeData);
		const {type, context} = polyNodeData;
		const nodesWithSameType = node.scene().nodesController.nodesByContextAndType(context as any, type as any);
		const newNode = BasePolyNodeSaveController.changeType(node, type);

		for (let nodeWithSameType of nodesWithSameType) {
			if (nodeWithSameType.graphNodeId() != newNode?.graphNodeId()) {
				BasePolyNodeSaveController.changeType(nodeWithSameType, type);
			}
		}
		return newNode;
	}
}
